import styles from './styles.module.css';

export function Beacon({ onHover, size = 50 }) {
  return (
    <div 
      className={styles.beacon}
      onMouseEnter={onHover}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <div className={styles.beaconPulse} />
      <div className={styles.beaconDot} />
    </div>
  );
}
